const cloudService=[
    {
        title: "Cloud Computing Service",
        description: "Our Virtual Environment Provisioning service provides on-demand, customizable Test and Disaster  Recovery (DR) environments. Instantly allocate resources like CPU, memory, and storage to ensure scalable and secure hosting for web applications. Available in SaaS, PaaS, and laaS models, this solution enables organizations to drive innovation and adapt to evolving business needs."
    }
]

export default cloudService;